import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tarifa-detalle',
  templateUrl: './tarifa-detalle.component.html',
  styleUrls: ['./tarifa-detalle.component.scss']
})
export class TarifaDetalleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
